import {
    FieldInCard,
} from 'app/types/form.types'

import {
    LocationType,
    TemperatureRangePreconditioned,
} from 'app/enums/label.enums'

import {
    Container,
} from '../../containers.types'

const getFields = (
    getAllowedValues: (obj: Record<string, string>) => Record<string, string>,
): FieldInCard<keyof Container>[] => {
    return [
        {
            title: 'SUMMARY',
            className: 'containerData',
            fields: [
                {
                    name: 'serialNumber',
                    componentName: 'InputSingleline',
                    labelKey: 'SERIAL_NUMBER',
                    disabled: true,
                },
                {
                    name: 'material',
                    componentName: 'InputSingleline',
                    labelKey: 'MATERIAL',
                },
                {
                    name: 'financingContract',
                    componentName: 'InputSingleline',
                    labelKey: 'FINANCING_CONTRACT',
                    disabled: true,
                },
                {
                    name: 'manufacturingTimestamp',
                    componentName: 'DateTimeZonedSelect',
                    disabled: true,
                    labelKey: 'MANUFACTURING_TIMESTAMP',
                },
                {
                    name: 'tempRange',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(TemperatureRangePreconditioned),
                    showInColumns: true,
                    required: true,
                    labelKey: 'TEMP_RANGE',
                },
            ],
        },
        {
            title: 'DESCRIPTION',
            className: 'containerDescription',
            fields: [{
                name: 'containerDescription',
                componentName: 'LongText',
                labelKey: 'CONTAINER_DESCRIPTION',
            }],
        },
        {
            title: 'LOCATION',
            className: 'location',
            fields: [{
                name: 'location',
                labelKey: 'LOCATION',
                componentName: 'LocationObjectSelector',
                filterLocationType: LocationType.ADDRESS,
                required: true,
            }],
        },
    ]
}

export default getFields
